import { AlertService } from '../../services/alert.service';
import {Component, Input, OnInit} from '@angular/core';
import { LocalisationService } from '../../services/localisation.service';
import { Zone } from '../../../identite/shared/classes/zone';
import { TRANSLATE } from '../../classes/translatable';
import { imgCardDrop } from '../../classes/animations';
import { FormControl } from '@angular/forms';
import { StorageService } from '../../services/storage.service';
import { AclAccess } from '../../../configuration/shared/classes/acl_access';

@Component({
    selector: 'app-admin-list-zone',
    templateUrl: './admin-list-zone.component.html',
    styleUrls: ['./admin-list-zone.component.css'],
    animations: [imgCardDrop]
})
export class AdminListZoneComponent implements OnInit {

    zones: Zone[];
    lstPays: any[];
    newZone = new Zone();
    selected = new FormControl(0);
    payId: string;
    aclConfig: AclAccess;

    @Input()
    triggerReload: () => void;

    constructor(
        private localisationService: LocalisationService,
        private alertService: AlertService,
        private storageService: StorageService
    ) { }

    ngOnInit() {
        this.aclConfig  = new AclAccess(this.storageService.getAcl('configuration'));
        this.zones = [];
        this.getPays();
    }


    getZones() {
        this.zones = [];
        this.localisationService.getZones(null, 'withAcl')
        .subscribe(retour => {
            if (retour.status === 200) {
                retour.data.forEach(element => {
                    this.zones.push(new Zone(element));
                });
            }
        });
    }


    getPays() {
        this.lstPays = [];
        this.localisationService.getPays()
        .subscribe(retour => {
            if (retour.status === 200) {
                retour.data.forEach(element => {
                    this.lstPays.push(element);
                    // Pays par defaut du soft
                    if (element.pay_ref === this.storageService.typeVersion) {
                        this.newZone.zne_pay_id = element.pay_id;
                        this.payId = element.pay_id;
                    }
                });
            }
        });
    }


    selectTab(event: any) {
        this.selected.setValue(event);
        if (event === 1) {
            this.getZones();
        }
    }

    insertZone(zone: Zone) {
        this.localisationService.insertZone(zone)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.newZone = new Zone({zne_pay_id: this.payId});
                this.alertService.success(TRANSLATE('Zone ajoutée avec succès'));
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    updateZone(zone: Zone) {
        this.localisationService.updateZone(zone.zne_id, zone)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Zone modifiée avec succès'));
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    deleteZone(zone: Zone) {
        this.localisationService.deleteZone(zone.zne_id)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Zone supprimée avec succès'));
                this.getZones();
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

}
